import { YStack, Text } from 'tamagui'
import type { TitleSlide as TitleSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, parseLinkedText } from './shared'

export function TitleSlide({ slide }: { slide: TitleSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner alignItems="center" style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        {slide.tagline && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            textTransform="uppercase"
            letterSpacing={3}
            style={{ fontSize: 'clamp(11px, 1.5vw, 16px)' }}
          >
            {slide.tagline}
          </Text>
        )}
        <Text
          fontFamily="$heading"
          fontWeight="700"
          textAlign="center"
          color={accentColor}
          style={{
            fontSize: 'clamp(36px, 6vw, 80px)',
            textShadow: `0 0 40px ${accentColor}30`,
            lineHeight: '1.1em',
          }}
        >
          {slide.headline}
        </Text>
        {slide.subline && (
          <YStack alignItems="center" gap="$1">
            {slide.subline.split('\n').map((line, i) => (
              <Text
                key={i}
                fontFamily="$body"
                color="$textSecondary"
                textAlign="center"
                style={{ fontSize: 'clamp(14px, 2vw, 24px)', maxWidth: '700px' }}
              >
                {parseLinkedText(line)}
              </Text>
            ))}
          </YStack>
        )}
        {slide.bottomTagline && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            textTransform="uppercase"
            letterSpacing={3}
            style={{ fontSize: 'clamp(11px, 1.5vw, 16px)' }}
          >
            {slide.bottomTagline}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
